module.exports = __webpack_public_path__ + "img/32.f7f8dfd0.png";